// video-center.js
import VideoCenter from './video-center';
import './video-center.scss';

// Slick options common to all contexts.
const slickOptionsCommon = {
  mobileFirst: true,
  adaptiveHeight: true,
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToScroll: 1,
};

const videoCenterConfig = {
  name: 'videoCenter',
  class: VideoCenter,
  querySelector: {
    articleContent: '.article-list__content',
    playlistContent: '.video-playlist .article-list__content',
    playlistWrapper: '.video-playlist',
    playerEl: '.video-playlist__player [id^="player"]',
    playerWrapper: '.video-playlist__player',
    headerToggleButton: '.video-header .toggle',
    videoTitle: '.video-header .video-title__text',
    videoCategoryLink:
      '.video-header .article-list__article-meta__category-link',
    videoCategoryText:
      '.video-header .article-list__article-meta__category-text',
    videoTime: '.video-header .article-list__article-meta__time',
    videoDescription: '.video-header .video-description',
  },
  querySelectorAll: {
    articles: '.article-list__article',
    articleTitles: '.article-list__article-title',
  },
  options: {
    playingClass: 'now-playing',
    upNextClass: 'up-next',
    iconTextClass: 'article-list__article-mediaicon-text',
    openMobileCollapseClass: 'video-playlist--mobile-collapse--open',
    mobileStickyClass: 'video-playlist--mobile-sticky',
    stickyExitButtonClass: 'video-playlist__sticky-exit-button',
    siteHeaderHeight: 65,
    slickOptions: {
      ...slickOptionsCommon,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 1,
          settings: {
            slidesToShow: 2.25,
            slidesToScroll: 2,
          },
        },
      ],
    },
  },
};

export default videoCenterConfig;
